var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 0 511 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 511,
    height: 512,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "029---Flower",
    fill: "none",
    transform: "matrix(8.931699, 0, 0, 8.931699, -2.840625, 8.133786)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 11.1c0 6.27-3.64 12.8-7.66 17.52-.6432494-.5819702-1.5883201-.6829393-2.34-.25-1.4141132-2.2859388-3.0594242-4.4204868-4.91-6.37.17 0-3.09-4.81-3.09-10.9 0-8 9-11 9-11s9 3 9 11z",
    style: {
      fill: "rgb(47, 73, 94)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 30.52c-2.606918.6260559-5.1408317 1.5243216-7.56 2.68-3.7542862.7811755-7.6419965.6404904-11.33-.41-7.61-2.47-7.68-12-7.68-12s5.67-7.59 13.28-5.12c6 1.94 11 7.38 14.29 12.7-.7680355.4204954-1.1732465 1.291699-1 2.15z",
    style: {
      fill: "rgb(0, 197, 142)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m29 40.09c-.3963409 3.8231692-1.7327388 7.4888158-3.89 10.67-4.7 6.47-13.74 3.61-13.74 3.61s-5.52-7.72-.82-14.19c3.66-5.04 10.45-8.18 16.45-9.66.1816906.8471426.8881794 1.480964 1.75 1.57-.193247 2.6681428-.1094662 5.3491294.25 8z",
    style: {
      fill: "rgb(16, 135, 117)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m46.63 54.37s-9 2.86-13.74-3.61c-3.7-5.09-4.57-12.49-4.1-18.67.8501302.0735967 1.6533227-.4002868 2-1.18 2.4857106 1.0251339 5.0689064 1.7957371 7.71 2.3 3.4956443 1.573071 6.5542453 3.9760123 8.91 7 4.74 6.44-.78 14.16-.78 14.16z",
    style: {
      fill: "rgb(0, 197, 142)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m57.53 20.83s-.07 9.49-7.68 12c-6 2-13.24.51-19-1.88.3473635-.7891534.1498791-1.7120907-.49-2.29 1.7415219-2.0577295 3.2662496-4.2895288 4.55-6.66 2.5709888-2.8255314 5.7899783-4.9841075 9.38-6.29 7.61-2.51 13.24 5.12 13.24 5.12z",
    style: {
      fill: "rgb(16, 135, 117)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6fb445f70e7b9d88080235caa8fe73ef.svg";
export { ForwardRef as ReactComponent };